/**
 * 社員マスタ用Form定義ファイル
 * 概要
 *  社員マスタ用のForm定義をまとめたファイル
 * 更新履歴
 *  2021/01/20 新規 小林
 */
import { FieldChildrenProp } from '@/services/hexabase/types';

/* eslint-disable @typescript-eslint/camelcase */
export const EmployeeRules = [
  {
    id: 'id',
    rule: ['is_uniq_account']
  },
  {
    id: 'email',
    rule: ['email']
  },
  {
    id: 'u_id',
    rule: ['is_uniq_account']
  },
  {
    // 電話番号書式チェック
    id: 'telephone_number',
    rule: ['wrong_format_for_number_and_hyphen']
  },
  {
    // 社員名全角チェック
    id: 'name',
    rule: ['fullwidth_only']
  },
  {
    // 社員名カナ全角カナチェック
    id: 'name_kana',
    rule: ['fullwidth_katakana_and_space_only']
  },
  {
    // 代理店ID半角英数字チェック
    id: 'agency_id',
    rule: ['alpha_num|agency_id_lengthCheck:9']
  }
];

export const employeeMasterForm = [
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'add_group',
    name: 'add_group',
    display_id: 'add_group',
    dataType: 'select',
    component: 'Button',
    props: {
      // ボタンテキスト
      value: '企業・グループ追加',
      // ボタンカラー (参考：https://vuetifyjs.com/ja/styles/colors/#sass-)
      color: 'primary',
      // ボタン name
      name: 'add_group',
      // ボタン 押下可能か否か
      isDisabled: false,
      addStyle: "font-size: 1.4rem; margin-top: 20px;"
    },
    sizeX: 1,
    sizeY: 1,
    col: 5,
    row: 0,
    show: true
  },
  {
    display_id: 'company_id',
    component: 'MasterSelectSetControl',
    dblookup: 'm_company',
    props: {
      label: '',
      name: 'company_id',
      value: '',
      columns: [],
      body: [],
      dialogTitle: 'グループ選択',
      outPutData: [{ label: '所属グループ', name: 'company_name', isDisabled: true }]
    },
    show: true,
    col: 0, //Gridで表示する開始コラム数(横)
    row: 0 //Gridで表示する行数(縦)
  },
  {
    display_id: 'display_employee_id',
    dataType: 'text',
    component: 'InputArea',
    show: false
  },
  {
    display_id: 'operation_authority_name',
    dataType: 'text',
    component: 'InputArea',
    show: false
  },
  {
    display_id: 'agency_id',
    props: {
      maxlength: 9
    },
    show: true
  },

  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    'search': false,
    'show_list': false,
    'as_title': false,
    'status': false,
    'fieldIndex': 1,
    'title_order': 1,
    'full_text': false,
    'unique': false,
    'min_value': '',
    'max_value': '',
    // ****** //
    'field_id': 'ステータス',
    'name': 'Status',
    'display_id': 'Status',
    'dataType': 'status',
    'component': 'StatusBox',
    'props':{
      'displayStatus' : '',
      'labelName':'ステータス',
      'name':'estimate_status',
    },
    'sizeX':1,
    'sizeY':1,
    'col':1,
    'row':0,
    'show': true,
  },
  {
    display_id: 'email',
    props: {
      labelText: 'メールアドレス（社内）'
    }
  },
  // 社員名
  {
    display_id: 'name',
    props: {
      placeholder: '36文字以内',
      maxlength: 36
    }
  },
  // 社員名カナ
  {
    display_id: 'name_kana',
    props: {
      placeholder: '32文字以内',
      maxlength: 32
    }
  },
  // 郵便番号
  {
    display_id: 'postal_code',
    component: 'Zipcode',
    props: {
      label: '郵便番号',
      name: '郵便番号'
    },
  },
  // 町村丁番地
  {
    display_id: 'machimura_street_address',
    props: {
      placeholder: '20文字以内',
      maxlength: 20
    }
  },
  // ビル・建物名
  {
    display_id: 'building_name',
    props: {
      placeholder: '26文字以内',
      maxlength: 26
    }
  },

];

export const employeeGroupForm: Array<FieldChildrenProp> = [
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'company_group',
    name: 'company_group',
    display_id: 'company_group',
    dataType: 'select',
    component: 'SelectArea',
    props: {
      name: 'company_group',
      label: 'グループコード',
      selectData: [],
      rules: '',
      isReadonly: true,
      isDisabled: true,
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 0,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'operation_authority_name',
    name: 'operation_authority_name',
    display_id: 'operation_authority_name',
    dataType: 'select',
    component: 'SelectArea',
    props: {
      name: 'operation_authority_name',
      label: '操作権限',
      selectData: [],
      rules: '',
      isReadonly: true,
      isDisabled: true,
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 0,
    show: true
  }
];

export const employeeAccountRegisterForm = [
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'activated_email_address',
    name: 'E-mailアドレス（システムアカウント）',
    display_id: 'activated_email_address',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      name: 'activated_email_address',
      labelName: 'E-mailアドレス（システムアカウント）',
      labelText: 'E-mailアドレス（システムアカウント）',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 0,
    show: true
  }
];

export const employeeAccountRegisterDialogForm = [
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'activated_email_address',
    name: 'E-mailアドレス（システムアカウント）',
    display_id: 'activated_email_address',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      name: 'activated_email_address',
      labelName: 'E-mailアドレス（システムアカウント）',
      labelText: 'E-mailアドレス（システムアカウント）',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 0,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'password',
    name: 'password',
    display_id: 'password',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '仮パスワード',
      labelText: '仮パスワード',
      name: 'password',
      isReadonly: false,
      isDisabled: false,
      rules: 'required',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 1,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'company_group',
    name: 'company_group',
    display_id: 'company_group',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '所属グループ',
      labelText: '所属グループ',
      name: 'company_group',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 2,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'operation_authority_name',
    name: 'operation_authority_name',
    display_id: 'operation_authority_name',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '操作権限',
      labelText: '操作権限',
      name: 'operation_authority_name',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 2,
    show: true
  }
];

/* eslint-disable-next-line @typescript-eslint/no-namespace */
namespace searchForm {
  export const EMPLOYEE_MAINTENANCE = [
    {
      'display_id': 'Status', //対象となるdisplay_id
      component: 'SelectArea', //任意で使用するコンポーネント
      col: 0, //Gridで表示する開始コラム数(横)
      props: {
        label: 'ステータス',
        name: 'Status',
        placeholder: '全ステータス'
      },
      row: 1, //Gridで表示する行数(縦)
      sizeX: 3, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      display_id: 'name',
      col: 0,
      row: 2,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      display_id: 'name_kana',
      col: 3,
      row: 2,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      display_id: 'position',
      col: 0,
      row: 3,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      display_id: 'division',
      col: 3,
      row: 3,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      display_id: 'telephone_number',
      col: 0,
      row: 4,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      display_id: 'activated_email_address',
      col: 3,
      row: 4,
      sizeX: 3,
      sizeY: 1,
      show: true,
      props: {
        labelText: 'E-mailアドレス（システムアカウント）',
      },
    },
    {
      'dataType': 'datetime',
      component: 'DatePickerRangeArea',
      display_id: 'account_activation_date',
      props: {
        format: 'yyyy/MM/dd',
        nameFrom: 'account_activation_date',
        nameTo: 'account_activation_date',
        valueFrom: '',
        valueTo: ''
      },
      col: 0,
      row: 5,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      'dataType': 'datetime',
      component: 'DatePickerRangeArea',
      display_id: 'account_invalidation_date',
      props: {
        format: 'yyyy/MM/dd',
        nameFrom: 'account_invalidation_date',
        nameTo: 'account_invalidation_date',
        valueFrom: '',
        valueTo: ''
      },
      col: 3,
      row: 5,
      sizeX: 3,
      sizeY: 1,
      show: true
    }
  ];
}
export const searchFormEmployeeList = searchForm.EMPLOYEE_MAINTENANCE;


export const addGroupDialogForm = [
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'company_name',
    name: 'company_name',
    display_id: 'company_name',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      name: 'company_name',
      labelName: '企業・グループ名',
      labelText: '企業・グループ名',
      isReadonly: false,
      isDisabled: false,
      rules: 'required',
      value: ''
    },
    sizeX: 2,
    sizeY: 1,
    col: 0,
    row: 0,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'company_group_code',
    name: 'company_group_code',
    display_id: 'company_group_code',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      name: 'company_group_code',
      labelName: 'グループコード',
      labelText: 'グループコード',
      isReadonly: false,
      isDisabled: false,
      rules: 'required|alpha_num',
      value: ''
    },
    sizeX: 2,
    sizeY: 1,
    col: 2,
    row: 0,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'remarks',
    name: 'remarks',
    display_id: 'remarks',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      name: 'remarks',
      labelName: '備考',
      labelText: '備考',
      isReadonly: false,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 4,
    sizeY: 1,
    col: 0,
    row: 1,
    show: true
  }
];